import { Button } from 'avo-ui'
import Select from 'components/commons/select'
import Search from 'components/commons/search'
import Sort from 'components/commons/sort'
import { SORT_BRAND, TABLE_BRAND } from 'configs/product/configTableBrandList'
import Table from 'components/commons/table'
import ModalConfirmation from 'components/commons/modal-confirmation'
import icLinkExternal from 'assets/images/ic-link-external.svg'
import ModalExport from 'components/commons/modal-export'

export const BrandList = ({
    dataList,
    modal,
    setShowModal,
    onSelectSort,
    query,
    onChangeQuery,
    selectedIds,
    statusOptions,
    selectedStatus,
    onChangeStatus,
    onExport,
    onConfirm,
    onSelectItemHandler,
    isLoading,
    isUpdating,
    isExporting,
}) => {
    return (
        <div className={'flex flex-col px-9 py-4'}>
            <div className={'flex gap-3 flex-wrap justify-between'}>
                <div className={'flex space-x-3'}>
                    <Search value={query?.search} onSearch={(key) => onChangeQuery({ search: key, page: 1 })} />
                    <Sort
                        options={SORT_BRAND}
                        value={`${query?.order_by}-${query?.order_type}`}
                        onSelect={(value) => onSelectSort(value)}
                    />
                    <Button
                        title={'Export'}
                        icon={icLinkExternal}
                        type={'outline'}
                        disabled={!dataList?.total_result}
                        onClick={() => setShowModal({ export: true })}
                    />
                </div>
                <div className={'flex space-x-3'}>
                    <Select
                        name={'status'}
                        className={'w-32'}
                        placeholder={'Select Status'}
                        options={statusOptions}
                        value={selectedStatus}
                        onChange={onChangeStatus}
                    />
                    <Button
                        title={'Apply'}
                        onClick={() => setShowModal({ confirm: true })}
                        disabled={!selectedIds?.length}
                    />
                </div>
            </div>
            <Table
                className={'my-3'}
                name={TABLE_BRAND.name}
                columns={TABLE_BRAND.column}
                data={dataList?.results}
                size={query?.limit}
                currentPage={query?.page}
                totalPage={dataList?.total_page}
                totalResult={dataList?.total_result}
                onSelectItem={(val) => onSelectItemHandler(val)}
                onChangePage={(val) => onChangeQuery({ page: val })}
                loading={isLoading}
                isResetSelectedItem={query?.search}
            />
            {modal?.export && (
                <ModalExport
                    show={modal?.export}
                    onHide={() => setShowModal({ export: false })}
                    description={'Are You Sure Export This?'}
                    totalData={selectedIds?.length || dataList?.total_result}
                    isLoading={isExporting}
                    onExport={onExport}
                />
            )}
            {modal?.confirm && (
                <ModalConfirmation
                    show={modal?.confirm}
                    onHide={() => setShowModal({ confirm: false })}
                    description={`Are You Sure to Change Brand Status to ${selectedStatus?.label}?`}
                    totalData={selectedIds?.length}
                    isLoading={isUpdating}
                    onConfirm={onConfirm}
                />
            )}
        </div>
    )
}
